//Bilder auf 1920 Breite skalieren
import background1 from './Background1.png'
import background2 from './Background2.png'
import background3 from './Background3.png'
import background4 from './Background4.png'
import background5 from './Background5.png'
import background6 from './Background6.png'
import background7 from './Background7.png'
import background8 from './Background8.png'

export default [
    background1,
    background2,
    background3,
    background4,
    background5,
    background6,
    background7,
    background8,
]